import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {useAppDispatch, useAppSelector} from "../../hooks/hooks";
import {DiffToNow, PadZero} from "../../utils/date-utils";
import TutorialSwipeElement from "./TutorialSwipeElement";
import {fetchSwipeState} from "../../store/tutorialSlice";


interface SwipeBlockProps {
    animationHeight: number
}

const TutorialSwipeBlock: React.FC<SwipeBlockProps> = ({animationHeight}) => {
    const swipeStateData = useAppSelector((state) => state.tutorial.swipes)
    const dispatch = useAppDispatch();
    const [timeLeft, setTimeLeft] = useState(DiffToNow(swipeStateData.time_to_next_hint));

    useEffect(() => {
        const timer = setInterval(() => {
            const left = DiffToNow(swipeStateData.time_to_next_hint);
            setTimeLeft(left);
            if(left.hours === 0 && left.minutes === 0 && left.seconds === 0) {
                clearInterval(timer);
                dispatch(fetchSwipeState());
            }
        }, 1000);
        return () => clearInterval(timer); // Clean up interval on component unmount
    }, [dispatch, swipeStateData.time_to_next_hint]);
    return (
        <Container>
            {swipeStateData.can_swipe ?
                <TutorialSwipeElement animationHeight={animationHeight} character={swipeStateData.character} />
                :
                <>
                    {!isNaN(timeLeft.hours) && timeLeft.seconds > 0 &&
                        <>
                            <p style={{width: '100%',fontSize: 16, fontWeight:700}}>Tutorial mode: <br/>Wait for the next symbol</p>
                            <Timer>{`${PadZero(timeLeft.hours)}:${PadZero(timeLeft.minutes)}:${PadZero(timeLeft.seconds)}`}</Timer>
                        </>
                    }
                </>
            }
        </Container>
    );
};

export default TutorialSwipeBlock;

const Container = styled.div`
    z-index: 10;
    color: #F1D988;
`;
const Timer = styled.h1`
    font-family: 'ZenDots', sans-serif;
    font-size: 46px;
    font-weight: 400;
    margin: 0 0 10.8vh; // 90px
    position: relative;
    cursor: pointer;
`;
